import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'amfe-flexible'
import './assets/css/iconfont.css'
import './assets/css/common.css'
import toast from './components/toast/index.js'
import loading from './components/loading/index.js'
import { ImagePreview, Picker, Field, Popup, Sticky, Empty } from 'vant';
import 'vant/lib/index.css';
// import VueImageSwipe from 'vue-image-swipe'
// import 'vue-image-swipe/dist/vue-image-swipe.css'
Vue.use(ImagePreview).use(Picker).use(Field).use(Popup).use(Sticky).use(Empty);
// Vue.use (VueImageSwipe);
Vue.prototype.$toast = toast
Vue.prototype.$loading = loading

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
